'use strict';

import { flow, action, observable, configure, makeObservable } from 'mobx';
configure({enforceActions: 'always'});

import {isTrue} from '@uw-it-sis/lib-react/lib/Utils'
import {States} from '@uw-it-sis/lib-react/lib/AppConstants';
import appStore from '@uw-it-sis/lib-react/lib/AppStore';

/**
 * Store for PlanSharedSelector.
 */
class PlanSharedSelectorStore {
    state = States.pending;

    constructor() {
        makeObservable(this, {
            state: observable,
            setSharedState: action
        });

        this.isPlanShared = false;
    }

    async getPlanShared() {
        let url = `api/plan/shared`;
        return await appStore.getHttpClient().doGet(url, 'getPlanShared');
    }

    async setPlanShared(shared) {
        let url = `api/plan/shared`;
        return await appStore.getHttpClient().doPost(url, shared, 'getPlanShared');
    }

    loadSharedPlanData = flow(function* () { // This a generator function!
        this.state = States.pending;

        try {
            this.isPlanShared = yield this.getPlanShared();
            this.state = States.done;
        } catch(error) {
            appStore.getExceptionUtils().handleException(error);
            this.state = States.error;
        }
    }.bind(this));

    /**
     * Handler for the updatePlanSharedState action.
     * @param newState The desired state of the plan: shared or notShared
     */
    updatePlanSharedState = flow(function* (newState) {
        this.state = States.pending;

        //  Hold steady if the state hasn't changed. (This shouldn't really happen, but if it does this will get things back in sync)
        if (this.isPlanShared === newState) {
            this.state = States.done;
            return;
        }
        try {
            yield this.setPlanShared(newState);
            // Set the new state if no exceptions were thrown.
            this.setSharedState(newState);
            this.state = States.done;
        } catch(error) {
            appStore.getExceptionUtils().handleException(error);
            this.state = States.error;
        }
    }.bind(this));

    setSharedState(isShared) {
        this.isPlanShared = isTrue(isShared);
    }
}

export default new PlanSharedSelectorStore();